var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailResendIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.122,
    viewBox: "0 0 24 19.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resend_email",
    "data-name": "resend email",
    transform: "translate(-183 -458.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M19.609,61H1.89A1.893,1.893,0,0,0,0,62.889v12.6a1.893,1.893,0,0,0,1.89,1.889H19.609A1.893,1.893,0,0,0,21.5,75.486v-12.6A1.893,1.893,0,0,0,19.609,61Zm-.261,1.26-8.559,8.559L2.157,62.26ZM1.26,75.225V63.144l6.067,6.014Zm.891.891,6.07-6.07,2.127,2.109a.63.63,0,0,0,.889,0l2.074-2.074,6.037,6.037Zm18.088-.891L14.2,69.188l6.037-6.037Z",
    transform: "translate(183 397.219)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_252",
    "data-name": "Ellipse 252",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(195 465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "refresh_4_",
    "data-name": "refresh (4)",
    transform: "translate(196.052 465.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M54.668,6.516a4.648,4.648,0,0,1,4.559-5.184V.082a.09.09,0,0,1,.144-.064l2.571,1.889a.079.079,0,0,1,0,.126L59.374,3.922a.089.089,0,0,1-.144-.064V2.611a3.366,3.366,0,0,0-3.044,2.063,3.324,3.324,0,0,0,.474,3.389.642.642,0,1,1-1.009.793A4.584,4.584,0,0,1,54.668,6.516Zm7.423-2.4A3.324,3.324,0,0,1,62.564,7.5,3.362,3.362,0,0,1,59.52,9.568V8.32a.09.09,0,0,0-.144-.064l-2.571,1.889a.079.079,0,0,0,0,.126l2.568,1.889a.089.089,0,0,0,.144-.064V10.847a4.648,4.648,0,0,0,4.559-5.184,4.56,4.56,0,0,0-.979-2.34.641.641,0,1,0-1.007.793Z",
    transform: "translate(-54.637 0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailResendIcon);
export default __webpack_public_path__ + "static/media/EmailResendIcon.3749f77e397ebef6d2a4960b90537a53.svg";
export { ForwardRef as ReactComponent };